import img1 from './quiz-images/putin.jpg';
import img2 from './quiz-images/canada-goose.jpg';
import img3 from './quiz-images/white-house.jpg';
import img4 from './quiz-images/firecracker.jpg';
import img5 from './quiz-images/samda-dancers.jpg';
import img6 from './quiz-images/kangaroo.jpg';
import img7 from './quiz-images/turban.jpg';
import img8 from './quiz-images/messi-maradona.jpg';
import img9 from './quiz-images/borat.jpg';
import img10 from './quiz-images/algae.jpg';

export default [
    {
        number: 1,
        image: img1,
        no: {
            name: 'PUTIN',
            tip: 'Se for deg at Putin sitter på en stoooor finger (ligner på 1-tallet)'
        }
    },
    {
        number: 2,
        image: img2,
        no: {
            name: 'KANADAGÅS',
            tip: 'Se for deg en svane (ligner på 2-tallet) som sloss med en Kanadagås'
        }
    },
    {
        number: 3,
        // tipNumbershape: '3-bra',
        image: img3,
        no: {
            name: 'DET HVITE HUS',
            // tip: 'Se for deg en BH (3-tallet) som henger i flaggstangen til det Hvite Hus'
            tip: 'Se for deg masken (3-tallet) som henger i flaggstangen i det Hvite Hus'
        }
    },
    {
        number: 4,
        image: img4,
        no: {
            name: 'KINAPUTTER',
            tip:
                'Se for deg og forestill deg lyden når en serie kinaputter smeller inne i en gigantisk bjelle (4-tallet)'
        }
    },
    {
        number: 5,
        image: img5,
        no: {
            name: 'SAMBADANSERE',
            tip: 'Se for deg at Kaptein Krok (5-tallet) ser på et show med samba-dansere'
        }
    },
    {
        number: 6,
        image: img6,
        no: {
            name: 'KENGURU',
            tip: 'Se for deg en binders (6-tallet) som holder fast pungen til en kenguru'
        }
    },
    {
        number: 7,
        image: img7,
        no: {
            name: 'TURBAN',
            tip: 'Se for deg en enorm turban på toppen av en klippe (7-tallet)'
        }
    },
    {
        number: 8,
        image: img8,
        no: {
            name: 'MESSI & MARADONA',
            tip: 'Se for deg at Maradona og Messi lager en snømann (8-tallet) sammen'
        }
    },
    {
        number: 9,
        image: img9,
        no: {
            name: 'BORAT',
            tip: 'Se for deg at Borat lukter på solsikken (9-tallet)'
        }
    },
    {
        number: 10,
        image: img10,
        no: {
            name: 'ALGER',
            tip: 'Se for deg et speedometer som spinner og sitter fast i alger (10-tallet)'
        }
    }
];
